module.exports = __webpack_public_path__ + "static/media/1.5_preview.94eaf4f7.png";